import wheelText, { type WheelTextVariant } from 'src/lib/assets/wheelText';

interface WheelTextProps {
  variant: WheelTextVariant,
}

export function WheelText(props: WheelTextProps) {
  return <div dangerouslySetInnerHTML={ { __html: wheelText.markup[props.variant] } } />;
}
